"use client"

import { Move3d } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Move3dIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Move3dIcon = component(Icon)({ as: Move3d })
